import { Metrics } from '../../../constants/Dashboards'
import { ActionsTypes } from '../../types'
import generateActionTypes from '../generateActionTypes'

const JLPMetrics: Metrics[] = [
  Metrics.JLP_BUTTONS,
  Metrics.JLP_DWELL_TIME_SKU,
  Metrics.JLP_SESSIONS_SKU,
]

const actionsTypes: ActionsTypes = generateActionTypes(JLPMetrics)

export type ArkActionTypes = typeof actionsTypes

export default actionsTypes
